export default {
  goodsStatusEnum: {
    '-1': 'Paiement en attente',
    0: "En cours d'examen",
    1: 'Confirmation en attente',
    2: 'Remboursement en attente',
    3: 'Retour de marchandises',
    4: 'Échange de marchandises',
    5: 'Vendeur expédié',
    6: 'Expédition séparée',
    7: 'Traitement différé',
    8: 'Livré',
    9: 'En cours de stockage',
    10: 'Stocké',
    11: 'Invalide',
    12: 'Détruit',
    13: 'Expiré',
    14: 'Confirmation des informations',
    15: "Confirmation d'achat",
    16: 'En attente de procédure de retour',
    17: "En attente de procédure d'échange",
    18: 'Traitement du retour',
    19: "Traitement de l'échange",
    20: 'Retourné',
    21: 'Échangé',
    22: 'Acheté',
    23: 'En cours de traitement',
    24: 'Annulé',
    25: 'Commande anormale',
    26: 'En attente de remboursement',
    27: 'En attente de réexpédition',
    28: 'Collecte en cours',
    29: 'Emballage terminé',
    30: "Expédié à l'international",
    31: 'Reçu',
    32: 'Paiement de la commande refusé',
    33: 'Contrôle des risques',
    34: 'Remboursement terminé',
    35: 'Liste des commandes gelées',
    36: 'Paiement de pré-souscription',
    37: 'En attente de collecte',
    38: 'Remboursement en cours',
    39: 'Marchandises rejetées',
    40: 'Rejet terminé',
    41: 'Exception : rupture de stock',
    42: 'Exception : en stock',
    43: 'Retour annulé',
    44: 'Échange annulé',
    45: 'Signé et en attente',
    46: 'Traitement des commandes',
    47: 'Traitement de la commande',
    48: 'Paiement terminé',
    49: 'Abandonné',
    50: 'Terminé',
    51: "Retour en attente d'approbation du vendeur",
    52: "Échange en attente d'approbation du vendeur",
    53: 'Colis retourné invalide',
    54: 'À générer',
    55: 'Traitement de la commande',
    58: 'Marchandises en transfert',
    61: `Traitement de la commande`,
    62: `Traitement de la commande`,
  },
  appendStatusEnum: {
    0: 'En attente',
    1: 'En cours de traitement',
    2: 'Annulé',
    3: 'Terminé',
    4: 'Retourné',
  },
  inviteStatusEnum: {
    0: 'Inactif',
    1: 'Actif',
  },
}
